import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { useAuth } from '../stores/auth';

export default function Home() {
  const nav = useNavigate();
  const insp = useAuth((s) => s.inspector);
  const logout = useAuth((s) => s.logout);

  return (
    <>
      <TopBar title="Inspector" />
      <main className="px-4 py-6 space-y-4 max-w-md mx-auto">
        <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm">
          <p className="text-xs text-gray-500 uppercase tracking-wide font-semibold">En servicio</p>
          <p className="text-lg font-bold text-gray-900 mt-1">{insp?.nombre} {insp?.apellido}</p>
          {insp?.legajo && (
            <p className="text-xs text-gray-400">Legajo: {insp.legajo}</p>
          )}
        </div>

        <button
          onClick={() => nav('/consultar')}
          className="w-full bg-brand-500 hover:bg-brand-600 text-white rounded-2xl py-5 px-5 flex items-center gap-4 shadow-md shadow-brand-500/20"
        >
          <span className="text-3xl">🔍</span>
          <span className="text-left">
            <span className="block text-base font-bold">Consultar patente</span>
            <span className="block text-xs text-brand-100">¿Está pagando estacionamiento?</span>
          </span>
        </button>

        <button
          onClick={() => nav('/labrar')}
          className="w-full bg-red-600 hover:bg-red-700 text-white rounded-2xl py-5 px-5 flex items-center gap-4 shadow-md shadow-red-500/20"
        >
          <span className="text-3xl">📝</span>
          <span className="text-left">
            <span className="block text-base font-bold">Labrar acta</span>
            <span className="block text-xs text-red-100">Infracción de tránsito o estacionamiento</span>
          </span>
        </button>

        <div className="pt-6 text-center">
          <button
            onClick={() => { logout(); nav('/login'); }}
            className="text-sm text-gray-400 hover:text-gray-700 underline"
          >
            Cerrar sesión
          </button>
        </div>
      </main>
    </>
  );
}
